import { render } from "./QuickMenus.vue?vue&type=template&id=72506864"
import script from "./QuickMenus.vue?vue&type=script&lang=js"
export * from "./QuickMenus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/QuickMenu/QuickMenus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72506864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72506864', __exports__)) {
    api.reload('72506864', __exports__)
  }
  
  module.hot.accept("./QuickMenus.vue?vue&type=template&id=72506864", () => {
    api.rerender('72506864', render)
  })

}


export default __exports__